import {Button, Stack, styled, TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useShallowSelector} from "../../shared/hooks";
import {userSelector} from "../../entities/user";
import {useEffect} from "react";
import {routes, wsWeddingRoutes} from "../../app/providers/router/routes";
import {ConnectButton} from "../../features/connect-button";
import {useNavigate} from "react-router-dom";
import {modalActions, ModalType} from "../../entities/modal";
import RingImagePng from "../../shared/assets/ring.png";
import Web3WedLogoPng from "../../shared/assets/web3wed-logo.png";
import {certificate, logoWhiteEngV} from 'shared/assets';
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import {dispatch} from "jest-circus/build/state";
import {useDispatch} from "react-redux";


const ButtonM = styled(Button)`
  padding: 12px 20px;
  font-weight: 600;
  font-size: 16px;
  border-radius: 63px;
  font-family: "Montserrat", sans-serif;
  margin-left: 20px;
  border: 2px solid #2DB3F6;
  cursor: pointer;
  height: 43px;
  transition: all 0.3s ease;
  color: #2DB3F6;
  background: #fff;
  &:hover {
    background: radial-gradient(
      95.29% 75.23% at 15.56% 11.62%,
      #3ACACF 0%,
      #3c5dfe 100%
    );
    border: 2px solid #2DB3F6;
    color: #fff;
  }
  @media (max-width: 768px) {
    padding: 8px 16px;
    margin-left: 0px;
    display: none;
  }
`;

export const StyledGift = styled('section')`
    margin-top: 20px;
    @media (max-width: 480px) {
        margin-top: 30px;
    }
    h2 {
        font-size: 28px;
        font-weight: 500;
        font-family: "YesevaOne", serif;
        color: #2B2B2B;
        line-height: 1.25!important;
        text-align: center;
        @media (max-width: 725px) {
            text-align: center;
            line-height: 54px;
        }
        @media (max-width: 480px) {
            font-size: 26px;
            line-height: 29px;
        }
    }
    h4 {
        font-size: 28px;
        font-weight: 500;
        font-family: "YesevaOne", serif;
        color: #2B2B2B;
        text-align: center;
        @media (max-width: 480px) {
            font-size: 24px;
        }
    }
    p {
        font-family: "CormorantInfant", serif;
        font-size: 20px;
        font-weight: 400;
        color: #2B2B2B;
        text-align: center;
        margin: 0;
        @media (max-width: 992px) {
            text-align: center;
        }
        @media (max-width: 480px) {
            font-size: 18px;
            line-height: 24px;
        }
    }
    span {
        font-size: 18px;
        font-weight: 300;
        color: #fff;
        opacity: 0.8;
    }
`;
const Title = styled('h1') `
  font-size: 2em;
  text-align: center;
  color: #00ffff; /* Cyan */
  margin-bottom: 10px;
`;

const Subtitle = styled('p')`
  font-size: 1em;
  text-align: center;
  margin-bottom: 20px;
  max-width: 600px;
`;

const RingImage = styled('div')`
  width: 100%;
  max-width: 200px;
  margin-bottom: 20px;
  /* Replace with your actual image URL or component */
  background-image: url(${RingImagePng});
  background-size: cover;
  aspect-ratio: 1 / 1; /* Make it a square */
  border-radius: 50%;
`;

const Quote = styled('p')`
  font-size: 1.5em;
  text-align: center;
  margin-bottom: 10px;
  font-style: italic;
`;

const Code = styled('p')`
  font-size: 2em;
  text-align: center;
  color: #00ffff; /* Cyan */
  margin-bottom: 10px;
`;

const ActivationText = styled('p')`
  font-size: 20px;
  text-align: center;
  margin: 0px;
`;

const LogoContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  img {
    width: 200px;
    background-color: #fff;
    margin: 180px 0 20px 0;
  }
`;

const Logo = styled('div')`
  /* Replace with your actual logo image URL or component */
  
`;

const Web3WedText = styled('h2')`
  font-size: 1.5em;
  text-align: center;
  margin-bottom: 5px;
`;

const ButtonRitual = styled('button')`
  padding: 17px 40px;
    margin-top: 75px;
    border: 2px solid #2DB3F6;
    box-shadow: 0px 0px 16px -2px rgba(45, 179, 246, 0.6);
    color: #2DB3F6;
    font-size: 18px;
    font-weight: 700;
    border-radius: 63px;
    background: transparent;
    font-family: "Montserrat", sans-serif;
    transition: background 0.3s ease;
    transform: translateY(-50px);
    animation: fadeInFromTop 1s ease-out forwards;
    animation-delay: 1s;

    &:hover {
      background: #fff;
      border-color: transparent;
      color: #000;
      cursor: pointer;
    }
    @media (max-width: 680px) {
        margin-top: 15px;
        font-size: 16px;
    }
`;

const Footer = styled('div')`
  font-size: 0.7em;
  text-align: center;
  color: #999;
  margin-top: auto; /* Push footer to the bottom */
  margin-bottom: 100px
`;

export const Gift = () => {
    const { id: userId } = useShallowSelector(userSelector.getUser);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if(userId) {
            navigate(routes.checkPromo.path);
        }
    }, [userId]);

    const handleButtonClick = () => {
        dispatch(
            modalActions.openModal( {
                type: ModalType.Loading,
                data: { title:"В процессе запуска", text: 'Оплата будет доступна 10 июня в данный момент можно зарегистрироваться и получить -15%'}
            }),
        );
    };
    return (
        <Stack sx={{display: 'flex', alignItems: 'center', padding: '0 30px'}}>
            <Stack maxWidth={1100}>
                <StyledGift>
                    <h2>Подарочный сертификат на цифровую церемонию Web3Wed</h2>
                    <Stack sx={{display: 'flex', alignItems: 'center', flexDirection: {xs: 'column', md:'row'}, justifyContent: 'space-between', gap: '50px', margin: '40px'}}>
                        <Stack sx={{ width: '50%', alignItems: 'center'}}><img width={200} src={certificate} alt='certificate'/></Stack>
                        <Stack sx={{fontSize:'14px',width: {xs: '100%', md:'50%'}, textAlign: 'center'}}>
                            <Stack sx={{fontWeight: 'bold', color: '#4f4f4f'}}>
                                Сертификат номиналом 9100 Р
                            </Stack>
                            <Stack sx={{padding:'15px 0'}}>
                                Предоставляет доступ к услугам:<br/>
                                • Доступ к цифровой церемонии<br/>
                                • Загрузка и хостинг видео-клятв<br/>
                                • Страница пары на Web3Wed.io<br/>
                                • Фиксация события в децентрализованном реестре Polygon
                            </Stack>
                            <Stack sx={{padding:'15px 0'}}>
                                Для активации введите код на сайте<br/>
                                https://web3wed.io<br/>
                                при оформлении заказа в поле "Промокод"
                            </Stack>
                            <Stack sx={{padding:'15px 0'}}>
                                Срок действия - 12 месяцев.<br/>
                                Не подлежит возврату или обмену.
                            </Stack>
                            <Stack sx={{padding:'15px 0'}}>
                                Церемония — символическое действие,<br/>
                                не является юридическим браком.
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack sx={{display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'center', margin: '20px'}}>
                        <ButtonRitual onClick={handleButtonClick}>
                         Купить сертификат
                        </ButtonRitual>
                    </Stack>
                    <Footer>
                        Дата: 03.05.2025 Действителен до: 03.05.2026<br />
                        Сертификат номиналом 9100 Р. срок действия 12 месяцев.<br />
                        Не подлежит возврату или обмену.<br />
                        Церемония — символическое действие, не является юридическим браком.<br />
                        ИП Серебренникова О. Ю. ИНН: 212884722710 ОГРНИП: 323210000023073<br />
                        Email: w3wruscert@yandex.com
                    </Footer>
                </StyledGift>

            </Stack>
        </Stack>
    );
};
